/* API client for the editable landing page (`/`).
 *
 * Public:
 *   landingApi.get()              — fetch the resolved {content, theme, seo}.
 *
 * Admin (cookie-auth, same as adminApi.*):
 *   landingAdminApi.get()         — like .get() but also includes `defaults`
 *                                    and `font_family_keys`.
 *   landingAdminApi.save(patch)   — PUT {content?, theme?, seo?}.
 *   landingAdminApi.reset()       — POST /admin/landing/reset.
 *   landingAdminApi.seoScore(seo) — POST /admin/landing/seo-score.
 *   landingAdminApi.seoSuggest({page_summary, audience}) — Claude SEO suggestion.
 */
import axios from 'axios';

const API = (process.env.REACT_APP_BACKEND_URL || '') + '/api';
const http = axios.create({ baseURL: API, withCredentials: true });

export const landingApi = {
  get: () => http.get('/landing').then((r) => r.data),
};

export const landingAdminApi = {
  get:        ()        => http.get('/admin/landing').then((r) => r.data),
  save:       (patch)   => http.put('/admin/landing', patch).then((r) => r.data),
  reset:      ()        => http.post('/admin/landing/reset').then((r) => r.data),
  seoScore:   (seo)     => http.post('/admin/landing/seo-score', { seo }).then((r) => r.data),
  seoSuggest: (body)    => http.post('/admin/landing/seo-suggest', body, { timeout: 30000 }).then((r) => r.data),
  regenerateFlag: (locale) => http.post('/admin/landing/flags/regenerate', { locale }, { timeout: 120000 }).then((r) => r.data),
};
